import easyApi from '@xsyx/easy-api-h5';
import { prefix, medusaPrefix } from '../../config'
const { registerModule } = easyApi();
// xps 服务
import xps from './modules/xps';
import staticPage from './modules/staticPage';
import user from './modules/user';
import cdns from './modules/cdns';
import fileManage from './modules/fileManage';
import deletes from './modules/delete';
import system from './modules/system';
import myFiles from './modules/myFiles';
import medusa from './modules/medusa';
import line from './modules/line';
import platform from './modules/platform';
import router from '../router';



// 响应请求拦截器 401重定向kylin验证
const hooks = {
    afterFetch: [
        (url, response, params, options) => {
            if (response.code === 401) {
                // kylin验证
                $kylinOidcAuth.signIn()
            } else if (response.code === 9401) {
                router.push('/401')
            }
        }
    ]
}


export const xpsApi = registerModule({ prefix, module: xps, hooks });
export const pageApi = registerModule({ prefix, module: staticPage, hooks });
export const userApi = registerModule({ prefix, module: user, hooks });
export const cdnsApi = registerModule({ prefix, module: cdns, hooks });
export const fileManageApi = registerModule({ prefix, module: fileManage, hooks });
export const deleteApi = registerModule({ prefix, module: deletes, hooks });
export const systemApi = registerModule({ prefix, module: system, hooks });
export const myFilesApi = registerModule({ prefix, module: myFiles, hooks });
export const lineApi = registerModule({ prefix, module: line, hooks });
export const platformApi = registerModule({ prefix, module: platform, hooks });
export const medusaApi = registerModule({ prefix, module: medusa, hooks });